/* eslint-disable import/no-dynamic-require */
const entities = require(`./${process.env.version}/entities`)
const menu = require(`./${process.env.version}/menu`)
const pages = require(`./${process.env.version}/pages`)

export { entities, menu, pages }
